import { COMMON_ONE_VERIFY_GENERAL_CONFIG } from "@common-shared/config/oneVerify/oneVerifyGeneral.config.ts"

import { FRONT_GENERAL_CONFIG } from "@front-shared/config/general.config.ts"

import { ROUTES_CONFIG } from "./routes.config"

export const GENERAL_CONFIG = {
    ...FRONT_GENERAL_CONFIG,
    ...COMMON_ONE_VERIFY_GENERAL_CONFIG,

    appName: "OneVerify",
    defaultPageTitle: "OneVerify",

    headerHeight: 74,
    insightsBackHeaderHeight: 64,

    appVersionRefreshLaterIgnoreMs: 5 * 60 * 1000, // 5 minutes

    // Window after a blocked demo mutation during which callers' generic
    // failure toasts are dropped, so only the demo warning toast is shown.
    demoBlockedMutationErrorToastSuppressionMs: 3 * 1000, // 3 seconds

    // Script element `id` — must match Produktly dashboard / loader snippet.
    produktlyScriptId: "produktlyScript",
    // Official Produktly browser bundle (async; queues calls until loaded).
    produktlyScriptUrl: "https://public.produktly.com/js/main.js",

    get supportedInsurersUrl(): string {
        const currentUrl = new URL(window.location.href)

        currentUrl.pathname = ROUTES_CONFIG.supportedPayersStandardUrl
        currentUrl.search = ""

        return currentUrl.toString()
    },

    get supportedInsurersDiscoverUrl(): string {
        const currentUrl = new URL(window.location.href)

        currentUrl.pathname = ROUTES_CONFIG.supportedPayersDiscoverUrl
        currentUrl.search = ""

        return currentUrl.toString()
    },

    get supportedInsurersAgenticUrl(): string {
        const currentUrl = new URL(window.location.href)

        currentUrl.pathname = ROUTES_CONFIG.supportedPayersAgenticUrl
        currentUrl.search = ""

        return currentUrl.toString()
    },
}
